import DesktopLayout from '../../layouts/DesktopLayout';
import InitContent from '../shared/InitContent';

export default function DesktopInitPage() {
  return (
    <DesktopLayout>
      <InitContent />
    </DesktopLayout>
  );
}
